// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"414":"cd38a0cb","456":"cd38a0cb","658":"cb885281","779":"cd38a0cb"}[chunkId] + ".chunk.css";
};